var actions = {
	next: "下一步",
	confirm: "確認",
	"continue": "繼續"
};
var errors = {
	unknown: "發生不明錯誤",
	contactSupport: "發生錯誤。請與支援人員聯繫。",
	tryAgain: "發生錯誤。請再試一次。",
	submit: "您的提交發生錯誤。"
};
var brands = {
	apple: "Apple",
	facebook: "Facebook",
	google: "Google",
	paypal: "PayPal",
	picarto: "Picarto",
	tiktok: "TikTok",
	trovo: "Trovo",
	twitch: "Twitch",
	youtube: "YouTube",
	twitter: "X (Twitter)",
	linkedin: "LinkedIn",
	streamlabs: "Streamlabs",
	mevo: "Mevo",
	typestudio: "TypeStudio"
};
var loginButton = {
	loginWith: "使用 {name} 登入",
	signupWith: "使用 {name} 註冊"
};
var alreadyHaveAccount = {
	company: "已經有 {company} 帳戶？",
	text: "已經有 Streamlabs ID？",
	link: "登入"
};
var noAccount = {
	text: "還沒有帳戶？",
	link: "註冊"
};
var validation = {
	email: {
		invalid: "請輸入有效的電子郵件地址"
	},
	password: {
		required: "需要密碼",
		min: "密碼必須多於 8 個字元",
		number: "密碼必須有數字",
		upper: "密碼必須包含大寫字元",
		special: "密碼必須有特殊字元"
	},
	username: {
		invalid: "名稱至少需有 5 個字元"
	},
	code: {
		minmax: "代碼應介於 6 到 10 個字元之間"
	}
};
var poweredBy = "由 <company>Streamlabs</company> 提供技術";
var card = {
	"404": {
		title: "找不到公司！",
		desc: "請稍後再試一次，或是與支援人員聯繫。"
	},
	company: {
		logoAlt: "{company} 標誌"
	}
};
var checkTfaForm = {
	tfaCodePlaceholder: "6 位數驗證代碼/8 位數備份代碼",
	successText: "成功！正在重新導向...",
	remember: "記住此裝置 30 天"
};
var createTfa = {
	scan: {
		title: "啟用雙因子驗證",
		lead: "按一下/複製或使用您慣用的驗證應用程式掃描下方代碼。建議使用 <app0 />、<app1 /> 或 <app2 /> 之類的應用程式，以安全存放您的代碼。",
		copied: "已複製！",
		instructions: "或是手動輸入此代碼到您的驗證應用程式。",
		copy: "複製代碼",
		proceed: "確認"
	},
	confirm: {
		title: "確認您的雙因子驗證",
		lead: "在下方提供產生的雙因子驗證代碼，以確認並啟用雙因子驗證。",
		label: "雙因子驗證代碼 (6 位數)",
		verify: "確認代碼",
		next: "成功！下一步"
	},
	save: {
		title: "儲存您的恢復代碼",
		lead: "在下方儲存您的恢復代碼，以防您無法存取雙因子驗證程式。關閉此模式後，這些代碼會再次可用。",
		label: "恢復代碼",
		download: "下載恢復代碼",
		copied: "代碼已複製！",
		finished: "完成"
	}
};
var emailLoginForm = {
	buttonText: "登入",
	emailPlaceholder: "電子郵件",
	passwordPlaceholder: "密碼"
};
var emailSignupForm = {
	buttonText: "註冊",
	emailPlaceholder: "設定電子郵件",
	passwordPlaceholder: "設定密碼",
	usernamePlaceholder: "您的姓名",
	ageLabel: "出生日期",
	agePlaceholder: "月/日/年",
	agreeText: "我同意 Streamlabs <terms>服務條款</terms>和<privacy>隱私權政策</privacy>。",
	agreeError: "請同意 Streamlabs 的條款與條件"
};
var ageInput = {
	invalidDate: "請輸入有效的生日",
	futureDate: "出生日期必須是過去的日期",
	minDate: "不可使用 {year} 年之前的日期",
	minAge_one: "您必須年滿 {years} 歲才能使用 Streamlabs",
	minAge_two: "您必須年滿 {years} 歲才能使用 Streamlabs",
	minAge_other: "您必須年滿 {years} 歲才能使用 Streamlabs"
};
var forgotPasswordForm = {
	emailPlaceholder: "電子郵件",
	back: "回到登入畫面",
	successText: "成功！我們已寄送給您密碼重設代碼",
	buttonText: "請求重設電子郵件",
	create: {
		successText: "成功！我們已傳送給您驗證碼，讓您可以開始使用！",
		buttonText: "申請驗證碼"
	},
	errors: {
		notFound: "找不到與此電子郵件關連的帳戶"
	}
};
var forgotPasswordCard = {
	forgot: {
	},
	title: "忘記您的密碼？",
	lead: "如果您需要重設密碼，請在下方輸入您的電子郵件，我們會寄送給您一封用來開始程序的電子郵件。",
	resetTitle: "重設您的密碼",
	resetLead: "您應已透過電子郵件收到代碼。填妥此表以重設您的密碼。",
	create: {
		title: "建立您的密碼",
		lead: "恭喜您建立您的 Streamlabs ID！再執行一個步驟，您就可以登入所有 Streamlabs 服務！",
		resetTitle: "選擇密碼",
		resetLead: "您應已透過電子郵件收到代碼。使用代碼填寫此表格以設定您的密碼。"
	},
	successText: "成功！正在重新導向...",
	signInTitle: "已經有帳戶？",
	signInBtn: "登入"
};
var checkTfaCard = {
	title: "雙因子驗證檢查",
	lead: "請在下方輸入雙因子驗證代碼以繼續。",
	successText: "雙因子驗證確認成功！",
	back: "返回"
};
var verifyEmailCard = {
	title: "確認您的電子郵件",
	lead: "檢查您的電子郵件以取得來自 Streamlabs 的 8 位數代碼，並在下方輸入此代碼。",
	back: "返回",
	successText: "電子郵件確認成功！"
};
var upgradeCard = {
	confirm: {
		title: "確認 {company} 連線",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"今後您可以使用提供的電子郵件和密碼登入 {company}。",
			"您可以使用您的 ID 從 Streamlabs 存取所有其他產品，並連線其他現有帳戶 (如果有的話)。",
			"您的 {company} 帳戶不會受此變更影響。"
		],
		button: "確認",
		cancel: "取消",
		switchAccount: "切換帳戶",
		success: "正在連線..."
	},
	confirmed: {
		title: "成功！",
		subtitle: "您的 Streamlabs ID 已建立，且已連線 {company} 帳戶。",
		text: "您可以在所有的 Streamlabs 產品上使用您的 Streamlabs ID。如果您有現有帳戶，可以在每個應用程式中將其連線到此 ID。",
		button: "關閉"
	},
	error: {
		user: "使用者識別失敗。請再嘗試登入，或是與支援人員聯繫。"
	}
};
var confirmCard = {
	confirm: {
		title: "確認 {company} 連線",
		subtitle: "我們找到具有相符電子郵件的帳戶。您要將此帳戶與 Streamlabs ID 合併嗎？",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"您可以使用透過 Streamlabs ID 提供的電子郵件和密碼登入 {company}。",
			"您可以使用您的 ID 從 Streamlabs 存取所有其他產品，並連線其他現有帳戶 (如果有的話)。",
			"您的公司帳戶不會受此變更影響。"
		],
		button: "確認",
		cancel: "取消",
		switchAccount: "切換帳戶",
		success: "正在連線..."
	},
	confirmed: {
		title: "成功！",
		subtitle: "您的 Streamlabs ID 已建立，且已連線 {company} 帳戶。",
		text: "您可以在所有的 Streamlabs 產品上使用您的 Streamlabs ID。如果您有現有帳戶，可以在每個應用程式中將其連線到此 ID。",
		button: "關閉"
	},
	error: {
		user: "使用者識別失敗。請再嘗試登入，或是與支援人員聯繫。"
	}
};
var upgradeConfirmCard = {
	confirm: {
		title: " 您的 ID 已經有已連線的 {company} 帳戶",
		subtitle: "您要解除與此已連線帳戶的連結，並連結到您目前的 Streamlabs 帳戶嗎？",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"您可以使用透過 Streamlabs ID 提供的電子郵件和密碼登入 Streamlabs。",
			"您可以使用您的 ID 從 Streamlabs 存取所有其他產品，並連線其他現有帳戶 (如果有的話)。",
			"您的 Streamlabs 帳戶不會受此變更影響。"
		],
		button: "確認",
		cancel: "取消",
		switchAccount: "切換帳戶",
		success: "正在連線...",
		agreeLabel: "我瞭解進行此連線，我即喪失對目前與 Streamlabs ID 綁定之現有 {company} 帳戶的存取權限。"
	},
	confirmed: {
		title: "成功！",
		subtitle: "您的 Streamlabs ID 已建立，且已連線 {company} 帳戶。",
		text: "您可以在所有的 Streamlabs 產品上使用您的 Streamlabs ID。如果您有現有帳戶，可以在每個應用程式中將其連線到此 ID。",
		button: "關閉"
	},
	error: {
		user: "使用者識別失敗。請再嘗試登入，或是與支援人員聯繫。"
	}
};
var loginCard = {
	title: "登入",
	lead: "使用 <id>Streamlabs ID</id> 登入到 <company>{company}</company>",
	accountExists: "您似乎有 <b>Streamlabs ID</b>。嘗試使用您的電子郵件登入。",
	forgotPassword: "忘記密碼？",
	successText: "成功！正在重新導向...",
	signInTitle: "使用某個平台登入"
};
var loginSourcesCard = {
	title: "登入",
	lead: "使用電子郵件/密碼登入",
	withSlId: "使用 Streamlabs ID 登入",
	noAccountMessage: "我們沒有找到與此登入方法關連的帳戶。請嘗試使用不同的登入方法，或如果您還沒有帳戶，請<signup>註冊</signup>。",
	accountExistsMessage: "您的 Twitch 電子郵件已經與 Streamlabs 建立關連。請嘗試使用您的 Streamlabs 電子郵件和密碼登入。"
};
var resetPasswordForm = {
	emailPlaceholder: "電子郵件",
	codePlaceholder: "6-8 位數電子郵件代碼",
	tfaCodePlaceholder: "雙因子驗證代碼",
	newPasswordPlaceholder: "新密碼",
	tfaError: "重設代碼應介於 6 到 10 個字元之間",
	next: "收到代碼了碼？",
	back: "回到「忘記密碼」",
	buttonText: "變更密碼",
	successText: "密碼重設成功",
	create: {
		back: "回到開始部分",
		buttonText: "設定密碼",
		successText: "密碼設定成功"
	}
};
var changePasswordForm = {
	currentPasswordPlaceholder: "目前的密碼",
	newPasswordPlaceholder: "新密碼",
	newPasswordConfirmationPlaceholder: "確認新密碼",
	buttonText: "變更密碼",
	successText: "密碼更新成功",
	newPasswordConfirmationError: "新密碼不相符",
	back: "回到儀表板"
};
var changePasswordCard = {
	title: "變更您的密碼",
	lead: "輸入您目前的密碼，然後在下方輸入新密碼。",
	successText: "密碼更新成功"
};
var removeTfaForm = {
	tfaCodePlaceholder: "6 位數驗證代碼/8 位數備份代碼",
	successText: "雙因子驗證移除成功",
	removeBtn: "確認與重設"
};
var removeTfaCard = {
	title: "移除雙因子驗證",
	lead: "在下方輸入雙因子驗證代碼，以從您的帳戶移除雙因子驗證。",
	successText: "雙因子驗證移除成功",
	back: "回到儀表板"
};
var verifyEmailForm = {
	codePlaceholder: "電子郵件提供的 8 位數代碼",
	tfaCodePlaceholder: "雙因子驗證代碼",
	emailPlaceholder: "電子郵件地址",
	buttonText: "確認電子郵件",
	successText: "電子郵件確認成功",
	requestBtn: "申請新代碼",
	requestingBtn: "申請中...",
	requestSuccess: "代碼已寄送到您的電子郵件",
	requestAgain: "於 {seconds} 秒內再次申請",
	tfaError: "重設代碼應介於 6 到 10 個字元之間",
	back: "返回"
};
var signupCard = {
	title: "註冊",
	lead: "建立 <id>Streamlabs ID</id> 帳戶已使用 <company>{company}</company>",
	successText: "成功！正在重新導向..."
};
var signupSourcesCard = {
	title: "註冊",
	lead: "建立 <id>Streamlabs ID</id> 帳戶已使用 <company>{company}</company>",
	withSlId: "建立 Streamlabs ID"
};
var connectCard = {
	connect: {
		title: "選擇帳戶",
		lead: "以繼續到 <b>{company}</b>",
		authorize: "驗證",
		authorizeSuccess: "成功！",
		cancel: "取消",
		disclaimer: {
			streamlabs: "若是繼續，會與 <b>{company}</b> 分享您的 Streamlabs ID (姓名、電子郵件地址、語言偏好設定、以及設定檔圖片)。透過授權 <b>{company}</b> 帳戶，您在此同意 <b>{company}</b> 的<privacy>隱私權政策</privacy>和<terms>服務條款</terms>。",
			"default": "若是繼續，Streamlabs 會與 <b>{company}</b> 分享您的姓名、電子郵件地址、語言偏好設定、以及設定檔圖片。透過授權 <b>{company}</b> 帳戶，您在此同意 <b>{company}</b> 的<privacy>隱私權政策</privacy>和<terms>服務條款</terms>。"
		},
		emailRequired: "繼續進行之前需要確認電子郵件",
		tfaRequired: "繼續進行之前需要雙因子驗證"
	},
	login: {
		title: "登入到 {company}",
		lead: "您必須登入才能連線到帳戶",
		loginBtn: "繼續登入"
	},
	error: {
		title: "登入到 {company}",
		lead: "目前無法確認您的申請。",
		verifyEmail: "確認電子郵件",
		verify2fa: "確認雙因子驗證"
	},
	"switch": {
		btn: "使用其他帳戶"
	}
};
var appsDropdown = {
	label: "Streamlabs 產品與應用程式",
	viewMore: "展開",
	viewLess: "折疊"
};
var platformButtons = {
	loginWithPlatform: "使用某個平台登入",
	signUpWithPlatform: "使用某個平台註冊",
	signUpLead: "我們支援直播到眾多平台，這些平台只是註冊時的選項。"
};
var ultraCheckoutCard = {
	title: "利用 <b>Streamlabs Ultra</b> 精進您的直播、品牌、編輯等能力",
	badge: "包含 <b>{planName}</b>",
	totalValue: "{price, currency} 費用",
	price: {
		month: "{price, currency}/月",
		year: "{price, currency}/年"
	},
	description: {
		month: "從一個地方獲得完整的優質功能，包括 <b>Streamlabs Desktop</b>、<b>控制台</b>、<b>Talk Studio</b>、<b>Podcast Editor</b>、<b>Cross Clip</b> 等，而且都以實惠的價格提供。",
		year: "從一個地方獲得完整的優質功能，包括 <b>Streamlabs Desktop</b>、<b>控制台</b>、<b>Talk Studio</b>、<b>Podcast Editor</b>、<b>Cross Clip</b> 等，而且都以實惠的價格提供。"
	},
	seeIncluded: "瞭解更多資訊",
	buyNow: "升級"
};
var ultraCheckoutBanner = {
	title: "利用 <b>Streamlabs Ultra</b> 精進您的直播、品牌、編輯等能力",
	badge: "包含 <b>{planName}</b>",
	totalValue: "{price, currency} 費用",
	price: {
		month: "{price, currency}/月",
		year: "{price, currency}/年"
	},
	description: {
		month: "從一個地方獲得完整的優質功能，包括 <b>Streamlabs Desktop</b>、<b>控制台</b>、<b>Talk Studio</b>、<b>Podcast Editor</b>、<b>Cross Clip</b> 等，而且都以實惠的價格提供。 <link />",
		year: "從一個地方獲得完整的優質功能，包括 <b>Streamlabs Desktop</b>、<b>控制台</b>、<b>Talk Studio</b>、<b>Podcast Editor</b>、<b>Cross Clip</b> 等，而且都以實惠的價格提供。 <link />"
	},
	seeIncluded: "瞭解更多資訊",
	buyNow: "升級"
};
var connect = {
	waitMessage: "合併資料。請不要關閉此視窗。"
};
var verifyPasswordCard = {
	success: "密碼確認成功",
	title: "請重新認證以確認",
	lead: "使用現有的電子郵件和密碼登入，以繼續更新您的 Streamlabs ID。",
	buttonText: "下一步"
};
var emailChangeForm = {
	agreeError: "請確認您是否瞭解此動作",
	buttonText: "下一步",
	emailPlaceholder: "新電子郵件地址",
	agreeText: "我瞭解驗證完成後，我的 Streamlabs ID 會在其所連接的所有 Streamlabs 產品上都造成變化。"
};
var verifyNewEmailCard = {
	title: "變更您的 Streamlabs ID",
	lead: "提供新的電子郵件作為您的 Streamlabs ID。我們會向該電子郵件地址寄送 6-8 位數的驗證碼。",
	successText: "新電子郵件可用"
};
var verifyNewEmailOwnershipCard = {
	title: "驗證您更新過的 Streamlabs ID",
	lead: "檢查您的電子郵件以取得來自 Streamlabs 的 8 位數代碼，並在下方輸入此代碼。",
	buttonText: "確認",
	back: "返回",
	codePlaceholder: "電子郵件提供的 8 位數代碼",
	successText: "電子郵件擁有狀態驗證成功"
};
var verifyTfaCard = {
	title: "雙因子驗證代碼",
	lead: "請輸入驗證應用程式提供的 6 位數驗證碼。",
	codePlaceholder: "6 位數代碼",
	buttonText: "確認",
	successText: "雙因子驗證已確認",
	back: "返回"
};
var ageGateForm = {
	ageLabel: "出生日期",
	agePlaceholder: "月/日/年"
};
var ageGateCard = {
	title: "完成帳戶設定",
	lead: {
		years: "您必須年滿 {years} 歲才能建立帳戶。<br />請輸入您的出生日期，以完成設定。",
		noYears: "您必須提供出生日期，才能建立帳戶。<br />輸入以完成設定。"
	},
	successText: "恭喜！帳戶設定完成。"
};
var zhTW = {
	actions: actions,
	errors: errors,
	brands: brands,
	loginButton: loginButton,
	alreadyHaveAccount: alreadyHaveAccount,
	noAccount: noAccount,
	validation: validation,
	poweredBy: poweredBy,
	card: card,
	checkTfaForm: checkTfaForm,
	createTfa: createTfa,
	emailLoginForm: emailLoginForm,
	emailSignupForm: emailSignupForm,
	ageInput: ageInput,
	forgotPasswordForm: forgotPasswordForm,
	forgotPasswordCard: forgotPasswordCard,
	checkTfaCard: checkTfaCard,
	verifyEmailCard: verifyEmailCard,
	upgradeCard: upgradeCard,
	confirmCard: confirmCard,
	upgradeConfirmCard: upgradeConfirmCard,
	loginCard: loginCard,
	loginSourcesCard: loginSourcesCard,
	resetPasswordForm: resetPasswordForm,
	changePasswordForm: changePasswordForm,
	changePasswordCard: changePasswordCard,
	removeTfaForm: removeTfaForm,
	removeTfaCard: removeTfaCard,
	verifyEmailForm: verifyEmailForm,
	signupCard: signupCard,
	signupSourcesCard: signupSourcesCard,
	connectCard: connectCard,
	appsDropdown: appsDropdown,
	platformButtons: platformButtons,
	ultraCheckoutCard: ultraCheckoutCard,
	ultraCheckoutBanner: ultraCheckoutBanner,
	connect: connect,
	verifyPasswordCard: verifyPasswordCard,
	emailChangeForm: emailChangeForm,
	verifyNewEmailCard: verifyNewEmailCard,
	verifyNewEmailOwnershipCard: verifyNewEmailOwnershipCard,
	verifyTfaCard: verifyTfaCard,
	ageGateForm: ageGateForm,
	ageGateCard: ageGateCard
};

export { zhTW as z };
//# sourceMappingURL=zh-TW.es.js.map
